import { useEffect, useState } from "react";
import { IoMdAdd } from "react-icons/io";
import loader from "../../../assets/images/loader.gif";
import TopHeader from "../../../components/dashboard/user-dashboard/TopHeader";
import {
  deleteMagazine,
  getAllMagzines,
} from "../../../service/DashboardService";
import ViewMag from "../../../components/dashboard/common/ViewMag";
import ListAction from "../../../components/dashboard/admin-dashboard/ListAction";
import AddMagazine from "../../../components/dashboard/admin-dashboard/magazine/AddMagazine";
import DoubleConfirm from "../../../components/dashboard/common/DoubleConfirm";

const AllMagagine = () => {
  const [magazines, setMagazines] = useState([]);
  const [loading, setLoading] = useState(false);
  const [activeTab] = useState("uploadMagazine");
  const [showAddMagazine, setShowAddMagazine] = useState(false);
  const [doubleAlert, setDoubleAlert] = useState(false);
  const [deletingMagazineId, setDeletingMagazineId] = useState(null);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    setLoading(true);
    try {
      const token = localStorage.getItem("accessToken");
      const response = await getAllMagzines(token);
      setMagazines(response.Magazines);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };

  const extractFileName = (url) => {
    const parts = url.split("/");
    const fileName = parts.pop();
    const cleanFileName = fileName.split("?")[0];
    return cleanFileName || "NA";
  };

  const handleDeleteMagazine = async (magazineId) => {
    setDeletingMagazineId(magazineId);
    setDoubleAlert(true);
  };

  const confirmDeleteMagazine = async () => {
    try {
      await deleteMagazine(deletingMagazineId);
      setMagazines((prevMagazines) =>
        prevMagazines.filter((mag) => mag.MagazineId !== deletingMagazineId)
      );
      setDeletingMagazineId(null);
      setDoubleAlert(false);
    } catch (error) {
      console.error("Error deleting Magazine:", error);
    }
  };

  const renderTableRows = () => {
    console.log(magazines);
    return magazines.map((mag, i) => {
      const Month = mag.Month;
      const Year = mag.Year;
      const fileName = extractFileName(mag.MagazineFile);
      const uploadDateTime = mag.UploadDataTime
        ? new Date(mag.UploadDataTime).toLocaleDateString("en-GB")
        : "NA";
      return (
        <tr
          key={i}
          className="bg-white border-b dark:bg-gray-800 dark:border-gray-700"
        >
          <td className="px-6 py-4">{fileName}</td>
          <td className="px-6 py-4">{Year}</td>
          <td className="px-6 py-4">{Month}</td>
          <td className="px-6 py-4">{mag.FileSize || "NA"}</td>
          <td className="px-6 py-4">{uploadDateTime}</td>
          <td className="px-6 py-4">
            <ListAction
              isUserDashboard={true}
              showDeleteButton={true}
              onDeleteClick={() => handleDeleteMagazine(mag.MagazineId)}
            />
          </td>
        </tr>
      );
    });
  };

  useEffect(()=>{
    console.log(showAddMagazine);
  },[showAddMagazine])

  return (
    <>
      <TopHeader />

      {/* <div className="flex items-center gap-4 mb-5">
        <button
          type="button"
          onClick={() => setActiveTab("viewBook")}
          className={`text-gray-900 bg-white border border-gray-300 focus:outline-none hover:bg-gray-100 focus:ring-4 focus:ring-gray-100 font-medium rounded-lg text-sm px-5 py-2.5 me-2 mb-2 dark:bg-gray-800 dark:text-white dark:border-gray-600 dark:hover:bg-gray-700 dark:hover:border-gray-600 dark:focus:ring-gray-700 ${
            activeTab === "viewBook" ? "bg-gray-200" : ""
          }`}
        >
          View Book
        </button>
        <button
          type="button"
          onClick={() => setActiveTab("viewMagazine")}
          className={`text-gray-900 bg-white border border-gray-300 focus:outline-none hover:bg-gray-100 focus:ring-4 focus:ring-gray-100 font-medium rounded-lg text-sm px-5 py-2.5 me-2 mb-2 dark:bg-gray-800 dark:text-white dark:border-gray-600 dark:hover:bg-gray-700 dark:hover:border-gray-600 dark:focus:ring-gray-700 ${
            activeTab === "viewMagazine" ? "bg-gray-200" : ""
          }`}
        >
          View Magazine
        </button>
        <button
          type="button"
          onClick={() => {
            setActiveTab("uploadMagazine");
            setShowAddMagazine(false);
          }}
          className={`text-gray-900 bg-white border border-gray-300 focus:outline-none hover:bg-gray-100 focus:ring-4 focus:ring-gray-100 font-medium rounded-lg text-sm px-5 py-2.5 me-2 mb-2 dark:bg-gray-800 dark:text-white dark:border-gray-600 dark:hover:bg-gray-700 dark:hover:border-gray-600 dark:focus:ring-gray-700 ${
            activeTab === "uploadMagazine" ? "bg-gray-200" : ""
          }`}
        >
          Upload Magazine
        </button>
      </div> */}

      {loading ? (
        <div className="flex justify-center ">
          <img src={loader} alt="Loading" />
        </div>
      ) : (
        <div>
          {activeTab === "viewMagazine" && <ViewMag />}
          {activeTab === "viewBook" && <div>Book</div>}
          {activeTab === "uploadMagazine" && (
            <>
              <div className="flex justify-end">
                <button
                  type="button"
                  className="flex items-center gap-2 text-gray-900 bg-gradient-to-r from-cyan-200 via-cyan-300 to-cyan-400 hover:bg-gradient-to-br focus:ring-4 focus:outline-none focus:ring-cyan-300 dark:focus:ring-cyan-800 font-medium rounded-lg text-sm px-5 py-2.5 text-center me-2 mb-2"
                  onClick={() => {
                    setShowAddMagazine(true);
                  }}
                >
                  <IoMdAdd /> Upload Magzine
                </button>
              </div>
              {showAddMagazine && <AddMagazine setShowAddMagazine={setShowAddMagazine}/>}

              {!showAddMagazine && (
                <table className="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400">
                  <thead className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
                    <tr>
                      <th scope="col" className="px-6 py-3">
                        File name
                      </th>
                      <th scope="col" className="px-6 py-3">
                        Year
                      </th>
                      <th scope="col" className="px-6 py-3">
                        Month
                      </th>
                      <th scope="col" className="px-6 py-3">
                        Size
                      </th>
                      <th scope="col" className="px-6 py-3">
                        Upload Date
                      </th>
                      <th scope="col" className="px-6 py-3">
                  
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {magazines.length === 0 ? (
                      <tr>
                        <td colSpan="4" className="text-center py-4">
                          No records found
                        </td>
                      </tr>
                    ) : (
                      renderTableRows()
                    )}
                  </tbody>
                </table>
              )}
            </>
          )}
        </div>
      )}
      <DoubleConfirm
        open={doubleAlert}
        setOpen={setDoubleAlert}
        onConfirm={confirmDeleteMagazine}
      />
    </>
  );
};

export default AllMagagine;